import { render, staticRenderFns } from "./RoundComponent.vue?vue&type=template&id=2ef304af&"
import script from "./RoundComponent.vue?vue&type=script&lang=js&"
export * from "./RoundComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports